export enum CalculationTaskStatusEnum {
  Created = 'created',
  Completed = 'completed',
}
